import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const storageService = inject(StorageService);
  // prevent SSR error
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const token = storageService.get('Login-SID');

  if (token) {
    const userDetails = storageService.get<any>('user-details');
    if (userDetails && userDetails.role.toLowerCase() === 'superadmin') {
      return router.createUrlTree(['/admin/dashboard']);
    }
    return router.createUrlTree(['/dashboard']);
  }

  return true;
}; 
